import React from 'react'
import './style.css'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import CardRow from './CardRow'
import { NotificationProps } from './types'
import { Icon } from '@iconify/react/dist/iconify.js'
import moment from 'moment'
import logo from '@/assets/images/auth/logo.png'
import { UpdateNotificationStatus } from '@/api/endpoints'

const Notification: React.FC<NotificationProps> = ({ setIsGetNotifications, userNotification: notification, toggleReload }) => {
  const { i18n, t } = useTranslation()
  const navigate = useNavigate()

  const markNotificationAsRead = () => {
    if (notification?.isRead) return

    UpdateNotificationStatus(notification?.id, i18n.language).then(res => {
      toggleReload?.(e => !e)
    }).catch(err => { })

  }

  const NavigateToNotification = () => {
    if (!notification?.screenId) return;
    const NoficationLink = `/profile/medical-request/${notification.relatedId}`
    setIsGetNotifications?.(false)
    navigate(NoficationLink)
  }

  if (!notification) return null;

  const ShownData = (date) => {
    const isToDate = moment(date).isSame(moment(), "day");
    const isYesterday = moment(date).isSame(moment().subtract(1, "day"), "day");
    const NotToDate = `${moment(date).format("DD-MM-yyyy")} `;
    return isToDate ? ` ${t("Today")}    ${moment(date).format("hh:mm A")}` : isYesterday ? ` ${t("Yesterday")}    ${moment(date).format("hh:mm A")}` : NotToDate;
  }


  return (
    <div onClick={markNotificationAsRead} className={`notification-container ${!notification?.isRead ? 'unRead' : "read-notification"}`}>

      <div style={{ backgroundImage: `url(${logo})` }} className='notification-logo'></div>
      <div className='notification-content'>

        <CardRow data={`# ${notification?.relatedId}`} cardClassName='related-id' />
        <CardRow data={notification?.body} cardClassName='MsgContent' />
        <CardRow
          isRender={!!notification.screenId}
          data={t("visit order")}
          dataClassName='link-action'
          cardClassName='MsgContent'
          onClick={NavigateToNotification}
        />
        <CardRow data={ShownData(notification?.date)} cardClassName='MsgDate' />

        <Icon onClick={NavigateToNotification} icon="fluent:eye-24-filled" className='arrow-icon' width={20} height={20} />
      </div>

    </div>
  )
}

export default Notification

